const config = {
  siteTitle: "Zen Polyclinic",
  siteTitleShort: "Zen Polyclinic has just been opened in Ataşehir",
  siteDescription:
    "As Zen Polyclinic, we are happy to provide you services with our competent team and result oriented treatments.",
  siteLogo: "/img/logo.svg",
  copyright: "Copyright © 2019. Zen Polyclinic",
  themeColor: "#c62828",
  backgroundColor: "#e0e0e0",
  siteDomain: "https://zenpoliklinik.com",
  en: {
    language: "Language",
    blogPage: {
      title: "BLOG",
      description: "Explanatory blog texts about the most questioned topics...",
      image: "/img/blog.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      popular: "Popular Posts",
      related: "RELATED POSTS",
      info: [
        {
          title: "baslik",
          content: "icerik",
        },
      ],
    },
    agingPage: {
      title: "Medical Aesthetic",
      description:
        "In medical aesthetic treatments, we provide various methods to slowdown the aging process and retrieve your younger outlook.",
      image: "/img/antiaging.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "OTHER SERVICES",
      related: "RELATED POSTS",
      info: [
        {
          title: "baslik",
          content: "icerik",
        },
      ],
    },
    laserPage: {
      title: "LASER TREATMENTS",
      description:
        "Laser Treatment is a method of removing unwanted hair or skin spots by practicing safe laser technologies.",
      image: "/img/laser-treatment.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "OTHER SERVICES",
      related: "RELATED POSTS",
      info: [
        {
          title: "baslik",
          content: "icerik",
        },
      ],
    },
    hairPage: {
      title: "HAIR TRANSPLANTATION",
      description:
        "Hair transplant is a practice which should be applied with care and professionalism by expert teams. Providing various hair transplant techniques, as Zen Polyclinic we ensure you that you would receive the most suitable technique and best results.",
      image: "/img/sac.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "OTHER SERVICES",
      related: "RELATED POSTS",
      info: [
        {
          title: "baslik",
          content: "icerik",
        },
      ],
    },
    bodyPage: {
      title: "Non-Surgical Body Contouring",
      description:
        "It is possible to attain a firmer skin without any surgical method, pain or ache.",
      image: "/img/body.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "OTHER SERVICES",
      related: "RELATED POSTS",
      info: [
        {
          title: "Non-Surgical Body Contouring",
          content: "Non-Surgical Body Contouring",
        },
      ],
    },
    docPage: {
      title: "Zen Documents",
      description: "Privacy Policy, Terms and Conditions, more.",
      image: "/img/about.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "OTHER SERVICES",
      related: "RELATED POSTS",
    },
    skinPage: {
      title: "Skin Care",
      description:
        "It is possible to attain a firmer skin without any surgical method, pain or ache.",
      image: "/img/skincare.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "OTHER SERVICES",
      related: "RELATED POSTS",
      info: [
        {
          title: "Skin Care",
          content: "Skin Care",
        },
      ],
    },
    servicesPage: {
      title: "Services",
      description:
        "Choose the most suitable one you need among our applications and take your place among Zen privileged guests.",
      image:
        "/img/warm-skin-tone.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "OTHER SERVICES",
      related: "RELATED POSTS",
      info: [
        {
          title: "Services",
          content: "Services",
        },
      ],
      menu: [
        {
          id: 0,
          title: "All Services",
        },
        {
          id: 1,
          title: "Medical Aesthetic",
        },
        {
          id: 2,
          title: "Body Contouring",
        },
        {
          id: 3,
          title: "HAIR TRANSPLANTATION",
        },
        {
          id: 4,
          title: "LASER TREATMENTS",
        },
        {
          id: 5,
          title: "Skin Care",
        },
      ],
    },
    technologiesPage: {
      title: "Technologies",
      description:
        "FDA approved, latest technology devices accepted in the world for skin problems are in Zen!",
      image: "/img/antiaging.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "OTHER SERVICES",
      related: "RELATED POSTS",
      info: [
        {
          title: "Technologies",
          content: "Technologies",
        },
      ],
    },
    teamPage: {
      title: "Our Team",
      description: "Our Team description",
      image: "/img/zenpoliklinik-musteriler.jpg",
      button: "Make an appointment",
      read: "Profile",
      other: "OTHER SERVICES",
      related: "RELATED POSTS",
      indexButton: "SHOW MORE",
      url: "/team/",
    },
    modal: {
      title: "Legal warning",
      content:
        "<strong><em>Private Zen Polyclinic</em></strong>, the information on the website should not be considered as a medical basis by visitors, and should not be considered as a basis for any treatment or home practice. The information on this site is not for advertising and / or medical instructions, it is a preliminary information about laser epilation and various medical aesthetic applications. Please consult your physician.",
      button: "OK",
    },
    header: {
      title: "Zen Polyclinic",
      description:
        "Give us a call to get detailed information about our treatments <strong><a href='tel:+902162120747'>+90 216 212 0747</a></strong>",
      button: "BOOK FREE",
      home: "/",
      offerButton: "Get Offer!",
      whatsapp: {
        number: "905421070747",
        message: "Hello!",
        info: [
          {
            title: "baslik",
            content: "icerik",
          },
        ],
      },
    },
    page404: {
      title: "PAGE NOT FOUND",
      content:
        "<p>The page you are looking for is temporarily unavailable.</p><p>If you keep coming back here please</p>",
      button: "contact us",
      url: "/contact/",
    },
    footer: {
      title: "Zen Polyclinic",
      description:
        "As Zen Polyclinic, we are happy to provide you services with our competent team and result oriented treatments.",
      address:
        "<br>Barbaros mah. Begonya sok. No:3J Nida Kule Kat:B1 Ataşehir - İstanbul, Türkiye",
      socialTitle: "FOLLOW US",
      contactUs: "CONTACT US",
      virtual: "Virtual Tour",
    },
    bookForm: {
      title: "REQUEST A BOOK",
      name: "Name",
      email: "E-mail Address",
      phone: "Phone Number",
      countryCode: "Country Code",
      messages: "Messages",
      button: "SUBMIT",
    },
    indexPage: {
      faqButton: "SHOW MORE",
      faqUrl: "/faq/",
    },
    contactPage: {
      title: "Thanks for your interest",
      content: "We shall contact you soon.",
    },
  },
  tr: {
    language: "Dil",
    blogPage: {
      title: "BLOG",
      description:
        "Zen Poliklinik hekimlerinin bilgileri ışığında oluşturulan blog içerikleri ile Enler Güzelliğinizin Emrinde.",
      image: "/img/blog.jpg",
      button: "DAHA FAZLASI",
      read: "Okumaya devam et →",
      popular: "Popüler Yazılar",
      related: "BAĞLANTILI YAZILAR",
      info: [
        {
          title: "baslik",
          content: "icerik",
        },
      ],
    },
    agingPage: {
      title: "Medikal Estetik",
      description:
        " Medikal Estetik yaşlanma sürecini yavaşlatmak için uygulanan yöntemlere denir. ZenPoliklinik Medikal Estetik işlemleri ile cilt hücrelerinin yenilenmesi, hormonların dengelenmesi hedeflenir.",
      image: "/img/antiaging.jpg",
      button: "DAHA FAZLASI",
      read: "Okumaya devam et →",
      other: "Diğer Hizmetlerimiz",
      related: "BAĞLANTILI YAZILAR",
      info: [
        {
          title: "Medikal Estetik",
          content: "<h2>baslik</h2><ul><li>madde 1</li><li>madde 2</li></ul>",
        },
      ],
    },
    laserPage: {
      title: "LAZER TEDAVİLERİ",
      description:
        "Lazer teknolojisi kullanılarak, vücutta bulunan istenmeyen tüyleri veya cildinizde bulunan lekeleri güvenli bir şekilde yok etme yöntemidir.",
      image: "/img/laser-treatment.jpg",
      button: "DAHA FAZLASI",
      read: "Okumaya devam et →",
      other: "Diğer Hizmetlerimiz",
      related: "BAĞLANTILI YAZILAR",
      info: [
        {
          title: "LAZER TEDAVİLERİ",
          content: "LAZER TEDAVİLERİ",
        },
      ],
    },
    docPage: {
      title: "Zen Dökümanlar",
      description: "Kullanım Koşulları, Çerez Politikası vb.",
      image: "/img/about.jpg",
      button: "DAHA FAZLASI",
      read: "Okumaya devam et →",
      other: "Diğer Hizmetlerimiz",
      related: "BAĞLANTILI YAZILAR",
    },
    hairPage: {
      title: "SAÇ EKİMİ",
      description:
        "Saç ekim işlemleri son derece titizlikle ve profesyonel bir biçimde, konusunda uzman kişiler tarafından yapılması gereken bir uygulamadır. Birden fazla saç ekim şeklinin bulunması, sizlere en uygun saç ekim yöntemlerinin gerçekleştirilmesinde avantajlar sağlamaktadır.",
      image: "/img/sac.jpg",
      button: "DAHA FAZLASI",
      read: "Okumaya devam et →",
      other: "Diğer Hizmetlerimiz",
      related: "BAĞLANTILI YAZILAR",
      info: [
        {
          title: "Saç Ekimi",
          content: "sac ekimi",
        },
      ],
    },
    bodyPage: {
      title: "AMELİYATSIZ VÜCUT ŞEKİLLENDİRME",
      description:
        "Herhangi bir ameliyat işlemine gerek kalmadan ağrısız ve acısız bir şekilde, çeşitli yöntemler kullanılarak cildinizin daha sıkı bir görünüme kavuşması artık mümkün.",
      image: "/img/body.jpg",
      button: "DAHA FAZLASI",
      read: "Okumaya devam et →",
      other: "Diğer Hizmetlerimiz",
      related: "BAĞLANTILI YAZILAR",
      info: [
        {
          title: "MELİYATSIZ VÜCUT ŞEKİLLENDİRME",
          content: "MELİYATSIZ VÜCUT ŞEKİLLENDİRME",
        },
      ],
    },
    skinPage: {
      title: "Cilt Bakımı",
      description:
        "Zen ile herhangi bir cerrahi yöntem, ağrı veya ağrı olmadan daha sıkı bir cilde ulaşmak mümkündür.",
      image: "/img/skincare.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "Diğer Hizmetlerimiz",
      related: "BAĞLANTILI YAZILAR",
      info: [
        {
          title: "Cilt Bakımı",
          content: "Cilt Bakımı",
        },
      ],
    },
    servicesPage: {
      title: "Hizmetler",
      description:
        "Uygulamalarımız arasından size en uygun olanını seçin ve Zen Poliklinik ayrıcalıklı misafirleri arasında yerinizi alın.",
      image:
        "/img/warm-skin-tone.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "Diğer Hizmetlerimiz",
      related: "BAĞLANTILI YAZILAR",
      info: [
        {
          title: "Hizmetler",
          content: "Hizmetler",
        },
      ],
      menu: [
        {
          id: 0,
          title: "Tüm Hizmetler",
        },
        {
          id: 1,
          title: "Medikal Estetik",
        },
        {
          id: 2,
          title: "AMELİYATSIZ VÜCUT ŞEKİLLENDİRME",
        },
        {
          id: 3,
          title: "SAÇ EKİMİ",
        },
        {
          id: 4,
          title: "LAZER TEDAVİLERİ",
        },
        {
          id: 5,
          title: "Cilt Bakımı",
        },
      ],
    },
    technologiesPage: {
      title: "Teknolojiler",
      description:
        "Cilt sorunları için Dünya'da kabul gören FDA onaylı, en yeni teknoloji cihazlar Zen'de!",
      image: "/img/antiaging.jpg",
      button: "SHOW MORE",
      read: "Keep Reading →",
      other: "Diğer Hizmetlerimiz",
      related: "BAĞLANTILI YAZILAR",
      info: [
        {
          title: "Teknolojiler",
          content: "Teknolojiler",
        },
      ],
    },
    teamPage: {
      title: "Ekibimiz",
      description: "Ekibimiz description",
      image: "/img/zenpoliklinik-musteriler.jpg",
      button: "Hızlı Randevu Al",
      read: "Profili Gör",
      indexButton: "DAHA FAZLASI",
      url: "/tr/team/",
    },
    modal: {
      title: "Yasal Uyarı",
      content:
        "<strong><em>Özel Zen Polikliniği</em></strong>, web sitesinde yer alan bilgiler ziyaretçiler tarafından tıbbi dayanak olarak ele alınmamalı, hiç bir tedavi veya evde uygulama için dayanak kabul edilmemelidir. Bu sitede yer alan bilgiler, reklam ve/veya tıbbi yönerge amaçlı değildir, lazer epilasyon ve çeşitli medikal estetik uygulamaları hakkında ön bilgilendirme niteliğindedir. Lütfen hekiminize danışın.",
      button: "Tamam",
    },
    header: {
      title: "Zen Poliklinik",
      description:
        "Uygulamalarımız hakkında detaylı bilgi almak için hemen bizi arayın. <strong><a href='tel:+902162120747'>0216 212 0747</a></strong>",
      button: "REZERVASYON",
      home: "/tr/",
      whatsapp: {
        number: "905421070747",
        message: "Merhaba",
      },
      offerButton: "Fiyat Sor!",
    },
    footer: {
      title: "Zen Poliklinik",
      description:
        "Zen Poliklinik olarak alanında uzman çalışanlarımız ve sonuç odaklı yöntemlerimizle sizlere hizmet vermekten mutluluk duymaktayız.",
      address:
        "<br>Barbaros mah. Begonya sok. No:3J Nida Kule Kat:B1 Ataşehir - İstanbul, Türkiye",
      socialTitle: "Bizi Takip Edin",
      contactUs: "Bize Ulaşın",
      virtual: "Sanal Tur",
    },
    page404: {
      title: "Zen Poliknik",
      content:
        "<p>Aradığınız sayfa geçici olarak kullanılamıyor. </p> <p> Buraya geri dönmeye devam ederseniz lütfen bizimle iletisime geciniz.</p>",
      button: "Bize Ulaşın",
      url: "/tr/contact/",
    },
    bookForm: {
      title: "RANDEVU AL",
      name: "Adınız",
      email: "E-mail Adresiniz",
      phone: "Telefon Numaranız",
      countryCode: "Ülke Kodu",
      messages: "Mesajınız",
      button: "GÖNDER",
    },
    indexPage: {
      faqButton: "DAHA FAZLASI",
      faqUrl: "/tr/faq/",
    },
    contactPage: {
      title: "İlginiz için teşekkür ederiz",
      content: "En kısa sürede sizinle iletişime geçilecektir.",
    },
  },
  de: {
    language: "Sprache",
    blogPage: {
      title: "BLOG",
      description:
        "Blog-Inhalte, die nach Kenntnissen unserer Ärzte erstellt sind, stehen Ihnen für Ihre Schönheit zur Verfügung.",
      image: "/img/blog.jpg",
      button: "Mehr dazu",
      read: "Weiterlesen →",
      popular: "Populäre Beiträge",
      related: "Passende Posts",
      info: [
        {
          title: "Titel",
          content: "Inhalt",
        },
      ],
    },
    agingPage: {
      title: "Medizinische Ästhetik",
      description:
        "Medizinische Ästhetik wird als Methode bezeichnet die den Alterungsprozess verlangsamt. Die medizinisch-ästhetischen Verfahren der Zen Poliklinik zielen darauf ab, Hautzellen zu regenerieren und Hormone auszugleichen.",
      image: "/img/antiaging.jpg",
      button: "Mehr dazu",
      read: "Weiterlesen →",
      other: "Leistungen",
      related: "Passende Posts",
      info: [
        {
          title: "	Medizinische Ästhetik",
          content: "<h2>baslik</h2><ul><li>madde 1</li><li>madde 2</li></ul>",
        },
      ],
    },
    laserPage: {
      title: "LASERBEHANDLUNGEN",
      description:
        "Die Lasertherapie ist eine Methode, mit der unerwünschte Haare oder Flecken auf der Haut sicher entfernt werden.",
      image: "/img/laser-treatment.jpg",
      button: "Mehr dazu",
      read: "Weiterlesen →",
      other: "Leistungen",
      related: "Passende Posts",
      info: [
        {
          title: "LASERBEHANDLUNGEN",
          content: "LASERBEHANDLUNGEN",
        },
      ],
    },
    docPage: {
      title: "Zen - Dokumente",
      description: "Nutzungsbedingungen, Cookie-Richtlinie usw.",
      image: "/img/about.jpg",
      button: "Mehr dazu",
      read: "Weiterlesen →",
      other: "Leistungen",
      related: "Passende Posts",
    },
    hairPage: {
      title: "HAARTRANSPLANTATION",
      description:
        "Haartransplantation ist eine Anwendung, die mit größter Sorgfalt und Professionalität von Experten auf ihrem Gebiet durchgeführt werden sollte. Als Zen Poliklinik bieten wir verschiedene Methoden der Haartransplantation und stellen sicher, dass Sie die effektivste Technik und die besten Ergebnisse erhalten.",
      image: "/img/sac.jpg",
      button: "Mehr dazu",
      read: "Weiterlesen →",
      other: "Leistungen",
      related: "Passende Posts ",
      info: [
        {
          title: "Saç Ekimi",
          content: "sac ekimi",
        },
      ],
    },
    bodyPage: {
      title: "KÖRPERFORMUNG OHNE OPERATION",
      description:
        "Es ist jetzt möglich, dass Ihre Haut durch verschiedene Methoden schmerzlos straffer aussieht, ohne dass eine Opertation erforderlich ist.",
      image: "/img/body.jpg",
      button: "Mehr dazu",
      read: "Weiterlesen →",
      other: "Leistungen",
      related: "Passende Posts",
      info: [
        {
          title: "KÖRPERFORMUNG OHNE OPERATION",
          content: "KÖRPERFORMUNG OHNE OPERATION",
        },
      ],
    },
    skinPage: {
      title: "Hautpflege",
      description:
        "Es ist möglich, dass Ihre Haut schmerzfrei straffer aussieht, ohne dass ein chirurgischer Eingriff erforderlich ist.",
      image: "/img/skincare.jpg",
      button: "Mehr dazu",
      read: "Weiterlesen →",
      other: "Leistungen",
      related: "Passende Posts",
      info: [
        {
          title: "Hautpflege",
          content: "Hautpflege",
        },
      ],
    },
    servicesPage: {
      title: "Leistungen",
      description:
        "Wählen Sie unter unseren Anwendungen die für Sie am besten geeignete aus und nehmen Sie Ihren Platz unter den privilegierten Zen-Gästen ein.",
      image:
        "/img/warm-skin-tone.jpg",
      button: "Mehr dazu",
      read: "Weiterlesen →",
      other: "Leistungen",
      related: "Passende Posts",
      info: [
        {
          title: "Leistungen",
          content: "Leistungen",
        },
      ],
      menu: [
        {
          id: 0,
          title: "Leistungen",
        },
        {
          id: 1,
          title: "Medizinische Ästhetik",
        },
        {
          id: 2,
          title: "KÖRPERFORMUNG OHNE OPERATION",
        },
        {
          id: 3,
          title: "HAARTRANSPLANTATION",
        },
        {
          id: 4,
          title: "LASERBEHANDLUNGEN",
        },
        {
          id: 5,
          title: "Hautpflege",
        },
      ],
    },
    technologiesPage: {
      title: "Technologien",
      description:
        "Von der FDA zugelassene, neueste technologische Geräte, die weltweit für Hautprobleme akzeptiert werden, sind in Zen.",
      image: "/img/antiaging.jpg",
      button: "Mehr dazu",
      read: "Weiterlesen →",
      other: "Leistungen",
      related: "Passende Posts",
      info: [
        {
          title: "Technologien",
          content: "Technologien",
        },
      ],
    },
    teamPage: {
      title: "Unser Team",
      description: "Ekibimiz description",
      image: "/img/zenpoliklinik-musteriler.jpg",
      button: "Schnelle Terminvereinbarung",
      read: "Profil anzeigen",
      indexButton: "Mehr dazu",
      url: "/de/team/",
    },
    modal: {
      title: "Rechtlicher Hinweis",
      content:
        "Die Informationen auf dieser Webseite sollten von den Besuchern nicht als medizinische Grundlage angesehen und nicht als Grundlage für eine Selbstbehandlung zu Hause akzeptiert werden. Die Informationen auf dieser Website dienen nicht der Werbung und/oder medizinischen Anleitung, sondern sind eine Vorabinformation über die Laser-Haarentfernung und verschiedene medizinisch-ästhetische Anwendungen. Bitte wenden Sie sich an Ihren Arzt.",
      button: "OK",
    },
    header: {
      title: "Zen Poliklinik",
      description:
        "Kontaktieren Sie uns für detaillierte Informationen. <strong><a href='tel:+902162120747'>+90 216 212 0747</a></strong>",
      button: "TERMIN VEREINBAREN ",
      home: "/de/",
      whatsapp: {
        number: "905421070747",
        message: "Hallo",
      },
      offerButton: "Nach Preis Fragen!",
    },
    footer: {
      title: "Zen Poliklinik",
      description:
        " Als Zen Poliklinik stehen wir Ihnen gerne mit unserem Fachpersonal und zielorientierten Methoden zur Seite",
      address:
        "<br>Barbaros mah. Begonya sok. No:3J Nida Kule Kat:B1 Ataşehir - İstanbul, Türkiye",
      socialTitle: "Folgen Sie uns",
      contactUs: "Kontaktieren Sie uns",
      virtual: "Virtuelle Tour",
    },
    page404: {
      title: "Zen Poliknik",
      content:
        "<p>Diese Webseite ist vorübergehend nicht verfügbar. </p> <p>Sollten Sie immer wieder auf diese Seite zurückkommen, kontaktieren Sie uns bitte..</p>",
      button: "Kontaktieren Sie uns",
      url: "/de/contact/",
    },
    bookForm: {
      title: "TERMIN VEREINBAREN",
      name: "Name",
      email: "E-Mail ",
      phone: "Telefon Nummer",
      countryCode: "Ländervorwahl",
      messages: "Ihre Nachricht",
      button: "SENDEN",
    },
    indexPage: {
      faqButton: "MEHR ERFAHREN",
      faqUrl: "/de/faq/",
    },
    contactPage: {
      title: "Vielen Dank für Ihr Interesse",
      content: "Sie werden schnellstmöglich kontaktiert",
    },
  },
  siteMenu: [
    {
      en: "HOME PAGE",
      tr: "ANA SAYFA",
      de: "STARTSEITE",
      url: "/",
    },
    {
      en: "HAIR TRANSPLANTATION & TREATMENTS",
      tr: "SAÇ EKİMİ & TEDAVİLERİ",
      de: "HAARTRANSPLANTATION & BEHANDLUNGEN",
      url: "/hair-transplantation/",
    },
    {
      en: "LASER TREATMENTS",
      tr: "LAZER TEDAVİLERİ",
      de: "LASERBEHANDLUNGEN",
      url: "/laser-treatments/",
    },
    {
      en: "MEDICAL AESTHETIC",
      tr: "MEDİKAL ESTETİK",
      de: "MEDIZINISCHE ÄSTHETIK",
      url: "/anti-aging/",
    },
    {
      en: "BODY CONTOURING",
      tr: "VÜCUT ŞEKİLLENDİRME",
      de: "KÖRPERFORMUNG",
      url: "/body-contouring/",
    },
    {
      en: "NUTRITION AND DIET",
      tr: "BESLENME VE DİYET",
      de: "ERNÄHRUNG UND DIÄT",
      url: "/diet/",
    },
    {
      en: "SKIN CARE",
      tr: "CİLT BAKIMI",
      de: "HAUTPFLEGE",
      url: "/skin-care/",
    },
    // {
    //   en: "OZONE THERAPY",
    //   tr: "OZON TERAPİSİ",
    //   de: "OZON-THERAPIE",
    //   url: "/ozon-terapisi/",
    // },
  ],
  topMenu: [
    {
      en: "Patient Guide",
      tr: "Hasta Rehberi",
      de: "Patientenleitfaden",
      url: "/faq/",
    },
    {
      en: "Services",
      tr: "Hizmetler",
      de: "Leistungen",
      url: "/services/",
    },
    {
      en: "Our Team",
      tr: "Ekibimiz",
      de: "Unser Team",
      url: "/team/",
    },
    {
      en: "Technologies",
      tr: "Teknolojiler",
      de: "Technologien",
      url: "/technologies/",
    },
    {
      en: "About Us",
      tr: "Hakkımızda",
      de: "Über Uns",
      url: "/about/",
    },
    {
      en: "Blog",
      tr: "Blog",
      de: "Blog",
      url: "/blog/",
    },
    {
      en: "360 Tour",
      tr: "360 Tur",
      de: "360 Grad Rundgang",
      url: "/360tour/",
    },
    {
      en: "Contact Us",
      tr: "Bize Ulaşın",
      de: "Kontaktieren Sie uns",
      url: "/contact/",
    },
  ],
  socialMenu: [
    {
      id: "facebook",
      icon: "/img/social/social-facebook.svg",
      url: "https://www.facebook.com/zenpoliklinik",
    },
    {
      id: "instagram",
      icon: "/img/social/social-instagram.svg",
      url: "https://www.instagram.com/zenpoliklinik",
    },
    {
      id: "twitter",
      icon: "/img/social/social-twitter.svg",
      url: "https://www.twitter.com/zen_poliklinik",
    },
    {
      id: "whatsapp",
      icon: "/img/social/social-whatsapp.svg",
      url: "https://wa.me/905421070747?text=Merhaba",
    },
    {
      id: "youtube",
      icon: "/img/social/social-youtube.svg",
      url: "https://www.youtube.com/channel/UCjI3YaIV24iW8ZzDXw2wC9g/featured?view_as=subscriber",
    },
  ],
};

module.exports = config;
